import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postDnataForm } from "../../redux/actions/dnataActions";

const ReferencesForm = ({ appData, postDnataFormFunc }) => {
  let initialData = {};
  if (appData.dnataOnboarding && appData.dnataOnboarding.references) {
    initialData = {
      ...initialData,
      ...appData.dnataOnboarding.references,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const initialState = {
    blurbSection6: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Section 6 - Character Reference Details"} />
          Please give the details of <bold>TWO</bold> people who have known you
          for <bold>at least FIVE years </bold> and who will be willing to
          provide a personal character reference for you.
          <br />
          <br />
          <bold>They should not be previous employers or relatives.</bold>
        </div>
      ),
    },
    blurbSection6a: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Referee 1"} />
        </div>
      ),
    },
    refName1: {
      title: "Full Name",
      value: getVal("refName1"),
      mandatory: true,
    },
    refAddress1: {
      type: "textarea",
      title: "Address",
      value: getVal("refAddress1"),
      mandatory: true,
    },
    refMobile1: {
      title: "Telephone",
      value: getVal("refMobile1"),
      mandatory: true,
    },
    refEmail1: {
      title: "Email Address",
      value: getVal("refEmail1"),
      mandatory: true,
    },
    blurbSection6b: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Referee 2"} />
        </div>
      ),
    },
    refName2: {
      title: "Full Name",
      value: getVal("refName2"),
      mandatory: true,
    },
    refAddress2: {
      type: "textarea",
      title: "Address",
      value: getVal("refAddress2"),
      mandatory: true,
    },
    refMobile2: {
      title: "Telephone",
      value: getVal("refMobile2"),
      mandatory: true,
    },
    refEmail2: {
      title: "Email Address",
      value: getVal("refEmail2"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postDnataFormFunc("references", {
      refRel1: "Friend",
      refRel2: "Friend",
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/dnata-onboarding");
  };

  return (
    <FormCreator
      formTitle={"Reference"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/dnata-onboarding")}
      onboardingBranch={"dnata"}
    />
  );
};
ReferencesForm.propTypes = {
  appData: any,
  postDnataFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postDnataFormFunc: postDnataForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(ReferencesForm);
